import { render } from "./BaseLabel.vue?vue&type=template&id=531e1de2"
import script from "./BaseLabel.vue?vue&type=script&lang=js"
export * from "./BaseLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__